<template>
  <el-row :gutter="8">
    <el-col :xs="24"
            :sm="10"
            :md="8"
            :lg="5"
            :xl="4">
      <avatar-upload></avatar-upload>
    </el-col>
    <el-col :md="16"
            :sm="14"
            :lg="19"
            :xl="20">
      <el-card>
        <el-form ref="form"
                 :model="form"
                 label-position="top">
          <el-form-item label="Email">
            <el-input :value="form.email"
                      :disabled="true"></el-input>
          </el-form-item>
          <!-- <el-form-item label="CO">
            <el-checkbox-group v-model="form.co"
                               :disabled="true">
              <el-checkbox label="MP"
                           name="co"></el-checkbox>
              <el-checkbox label="BEP"
                           name="co"></el-checkbox>
            </el-checkbox-group>
          </el-form-item> -->
          <el-form-item label="AUTHOR NAME">
            <el-input v-model="form.bookName"
                      placeholder="AUTHOR NAME"></el-input>
          </el-form-item>
          <el-form-item label="INCOME TAX AUTHOR NAME">If different from Author Name
            <el-input v-model="form.incomeName"
                      placeholder="If different from Author Name"></el-input>
          </el-form-item>
          <el-form-item label="ADDRESS">
            <el-input v-model="form.address"
                      placeholder="ADDRESS"></el-input>
          </el-form-item>
          <el-form-item label="BIOGRAPHY">
            <el-input type="textarea"
                      :rows="5"
                      v-model="form.biography"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       @click="updateProfile">Update</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import AvatarUpload from './AvatarUpload';
export default {
  components: { AvatarUpload },
  created() {
    this.axios({
      method: 'get',
      url: `/user/${localStorage.userID}/profile`,
    }).then(res => {
      this.form = res.data.user;
    });
  },
  data() {
    return {
      form: {
        email: '',
        co: [],
        bookName: '',
        incomeName: '',
        biography: '',
        role: 0,
      },
    };
  },
  compputed: {
    updateForm() {
      const form = {
        bookName: this.form.bookName,
        incomeName: this.form.incomeName,
        biography: this.form.biography,
      };
    },
  },
  methods: {
    updateProfile() {
      this.axios({
        method: 'put',
        url: `/user/${localStorage.userID}/profile`,
        data: this.form,
      }).then(res => {
        this.$message({
          message: 'Profile update success!',
          type: 'success',
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/user/Profile.vue